module.exports = __webpack_public_path__ + "img/top-img.895ba62b.png";